import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_GET_USER_METRICS } from "../../../config/api";

export const getUserAnalytcs = createAsyncThunk(
  "getUserAnalytcs/get",
  async (data, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path: API_GET_USER_METRICS,
      });
      return data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
